import {
  ADD_COUPON_FAILURE,
  ADD_COUPON_REQUEST,
  ADD_COUPON_SUCCESS,
  SET_COUPON_ADDED,
} from 'constants/index';
import type { RootState } from 'reducers/types';
import type { Dispatch } from 'redux';

export const addCoupon =
  ({ id, token, couponCode }) =>
  async (dispatch: Dispatch, _getState: () => RootState, { orders }: any) => {
    dispatch({ type: ADD_COUPON_REQUEST });

    try {
      const response = await orders.addCoupon({ id, token, couponCode });
      dispatch({ type: ADD_COUPON_SUCCESS, payload: response });
      dispatch({ type: SET_COUPON_ADDED, payload: true });
    } catch (error) {
      dispatch({ type: ADD_COUPON_FAILURE });
      throw error;
    }
  };
